import { SECTION_CARD } from '@/components/ui/section-card-variants'
import { cn } from '@/lib/utils'

/**
 * Certificates' boxes — the issued-certificate grid and its cards — shared with
 * `CertificatesSkeleton` so the pending page is the loaded layout's own shape
 * (docs/route-loading.md, "Skeletons").
 */
export const CARD_GRID = 'grid grid-cols-1 gap-6 @2xl:grid-cols-2'

/**
 * One issued certificate: the panel, its head over a hairline over its code and actions. rest:ln
 * (mock `cert-card`): 20 inside and 20 between, half the column wide, 24 apart.
 */
export const CARD_BOX = cn(SECTION_CARD, 'flex flex-col gap-5 p-5')

/** The seal beside the title: a 44px circle, so the head row is 44 tall whatever it holds. */
export const SEAL_BOX = 'flex size-11 shrink-0 items-center justify-center rounded-full'
